export const imageFormats = [".png", ".jpg", ".jpeg"];
